import { LogOut } from 'lucide-react';
import { Outlet } from 'react-router';

import { Button } from '@/components/ui/button';
import { useLanguage } from '@/modules/common/application/context/language';
import { useUser } from '@/modules/common/application/context/user';
import useLogout from '@/modules/common/application/use-logout';
import { LanguageCode } from '@/modules/common/types';

export const NewOnboardingLayout = () => {
  const { logout } = useLogout();
  const { company } = useUser();
  const { language, setLanguage } = useLanguage();

  const handleLogout = async () => {
    await logout(company?.tenantId ?? undefined);
  };

  const toggleLanguage = () => {
    const newLang = language === LanguageCode.EN ? LanguageCode.DE : LanguageCode.EN;
    setLanguage(newLang);
  };

  return (
    <div className="relative min-h-screen">
      <div className="absolute top-4 right-4 flex gap-2">
        <Button variant="ghost" onClick={toggleLanguage} className="px-3">
          {language === LanguageCode.DE ? 'DE' : 'EN'}
        </Button>
        <Button size="icon" variant="ghost" onClick={handleLogout} aria-label="Logout">
          <LogOut className="h-5 w-5" />
        </Button>
      </div>
      <div className="flex flex-col items-center justify-center h-screen">
        <Outlet />
      </div>
    </div>
  );
};
